import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'

import BkFlowRoomSpecialPackages from './BkFlowRoomSpecialPackages'
import BkFlowRoomDetails from './room-details/BkFlowRoomDetails'

import getValidSpecialPackages from '../../utilities/content/hasValidSpecialPackages'

// GA events handler
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

// Import activeRoom & activeStep actions
import setActiveRoom from '../../actions/setActiveRoomActions'
import setActiveStep from '../../actions/activeStepActions'
import manageMultiRoom from '../../actions/multiRoomActions'
import fetchAvailabilityData from '../../actions/fetchAvailability'
import fetchEnhancementsData from '../../actions/fetchEnhancements'
import fetchRoomRateDetails from '../../actions/fetchRoomRateDetails'

import BkFlowRoomCardDefault from './layouts/BkFlowRoomCardDefault'
import BkFlowRoomCardDefaultGrid from './layouts/BkFlowRoomCardDefaultGrid'
import BkFlowRoomCardCondensed from './layouts/BkFlowRoomCardCondensed'
import BkFlowRoomCardMultiStage from './layouts/BkFlowRoomCardMultiStage'
import BkFlowRoomCardRateStage from './elements/multi-stage/BkFlowRoomCardRateStage'
import BkFlowRoomCardUpSells from './upsells/BkFlowRoomCardUpSells'
import BkFlowRoomCardDefaultSelectButton from './elements/default/configured/BkFlowRoomCardDefaultSelectButton'
import BkFlowRoomCardSkipStepButton from './elements/BkFlowRoomCardSkipStepButton'
import BkFlowRoomCardVirtualTour from './elements/BkFlowRoomCardVirtualTour'
import BkFlowRoomCardDynamicRatesAccordion from './elements/default/dynamic/BkFlowRoomCardDynamicRatesAccordion'
import BkFlowRoomCardDynamicRatesDrawer from './elements/default/dynamic/BkFlowRoomCardDynamicRatesDrawer'

import placeholderImage from '../../assets/images/placeholder-image.png'
import zoomOpenIcon from '../../assets/icons/zoom-open.svg'
import zoomCloseIcon from '../../assets/icons/zoom-close.svg'

import moment from 'moment'
import _ from 'lodash'
import yn from 'yn'

import '../../styles/css/components/room/bk-flow-room-cards.css'
import '../../styles/css/components/room/bk-flow-notification.css'
import 'react-image-gallery/styles/css/image-gallery.css'

class BkFlowRoomCard extends Component {
	constructor(props) {
		const {
			urlData,
			cards,
			roomKey
		} = props

		let currentRateVal = null,
				queriedRateVal = null,
				comparablePayNowRates = [],
				comparablePayLaterRates = []

		// retrieve rate data matching roomType
		const roomTypeRates = cards.viewExtensions.roomRates

		// search matching rate data for comparable ratePlans to config value
		for (let ratePlan in roomTypeRates) {
			const currentRoomRates = roomTypeRates[ratePlan]

			// find payNow rates comparable to config value
			if (currentRoomRates.ratePlanCode.includes(process.env.REACT_APP_COMPONENT_RATE_PAY_NOW)) {
				comparablePayNowRates.push(roomTypeRates[ratePlan])
			}

			// find payLater rates comparable to config value
			if (currentRoomRates.ratePlanCode.includes(process.env.REACT_APP_COMPONENT_RATE_PAY_LATER)) {
				comparablePayLaterRates.push(roomTypeRates[ratePlan])
			}

			// find queried rates rates comparable to url parameter value
			if (currentRoomRates.ratePlanCode === urlData.ratePlanCode) {
				queriedRateVal = roomTypeRates[ratePlan].ratePlanCode
			}
		}

		// initialize variables for data grouping and filtering of best rate by type
		let payNowData = '',
				payLaterData = '',
				bestPayNowRate = '',
				bestPayLaterRate = ''

		// reduce cards ONLY with comparable payNow rates
		if (!_.isEmpty(comparablePayNowRates)) {
			let lowestPayNowRate = null

			payNowData = comparablePayNowRates.reduce(function (res, obj) {
				if (obj.rates && _.get(obj.rates, '[0].total.amountAfterTax')) {
					lowestPayNowRate = obj.rates[0].total.amountAfterTax < res.rates[0].total.amountAfterTax ? obj : res
				}

				return lowestPayNowRate
			})
		}


		// reduce cards ONLY with comparable payNow rates
		if (!_.isEmpty(comparablePayLaterRates)) {
			let lowestPayLaterRate = null

			payLaterData = comparablePayLaterRates.reduce(function (res, obj) {
				if (obj.rates && _.get(obj.rates, '[0].total.amountAfterTax')) {
					lowestPayLaterRate = obj.rates[0].total.amountAfterTax < res.rates[0].total.amountAfterTax ? obj : res
				}

				return lowestPayLaterRate
			})
		}

		// assign best pay now / pay later ratePlanCode to local state
		if (!_.isEmpty(payNowData)) {
			bestPayNowRate = payNowData.ratePlanCode
		}
		if (!_.isEmpty(payLaterData)) {
			bestPayLaterRate = payLaterData.ratePlanCode
		}

		super(props)

		let isRoomDetailsExpanded = false,
				isSpecialPackagesExpanded = false

		// Open room details accordion for specific card
		if (
			urlData.toggleRoomDetails &&
			Number(urlData.toggleRoomDetails) === Number(roomKey)
		) {
			isRoomDetailsExpanded = true
		}

		// Open special offers accordion for specific card
		if (
			urlData.toggleSpecialOffers &&
			Number(urlData.toggleSpecialOffers) === Number(roomKey)
		) {
			isSpecialPackagesExpanded = true
		}

		let bestPayFeaturedRate = null

		if (
			cards &&
			cards.viewExtensions &&
			cards.viewExtensions.featuredRatePlans &&
			cards.viewExtensions.featuredRatePlans[0]
		) {
			bestPayFeaturedRate = cards.viewExtensions.featuredRatePlans[0]
		}

		this.state = {
			queriedRate: queriedRateVal,
			payNowRate: bestPayNowRate,
			payLaterRate: bestPayLaterRate,
			payFeaturedRate: bestPayFeaturedRate,
			activeRateId: '',
			currentRoomType: props.cards.roomTypeCode,
			currentRateCode: currentRateVal,
			showNotification: false,
			specialPackagesExpanded: isSpecialPackagesExpanded,
			roomDetailsExpanded: isRoomDetailsExpanded,
			galleryFullScreen: false,
			roomDescriptionExpanded: false,
			roomAdaDescriptionExpanded: false,
			roomRateStageExpanded: false,
			currentUpSells: null,
			upSellsExpanded: false,
			virtualTourExpanded: false,
			isTaxInclusiveProperty: false,
			displayedPriceFrequency: 'per stay'
		}

		this.handleSpecialPackagesAccordion = this.handleSpecialPackagesAccordion.bind(this)
	}

	componentDidMount() {
		const {
			cards,
			configData,
			availabilityData,
			loyaltyRatesData,
			urlData
		} = this.props

		const {
			queriedRate,
			payNowRate,
			payLaterRate,
			payFeaturedRate
		} = this.state

		let matchedProperty = null
		let activeHotelCode = null

		// Get hotel code from avail response
		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (
			!_.isEmpty(matchedProperty) &&
			matchedProperty.displayPricesTaxInclusive
		) {
			this.setState({
				isTaxInclusiveProperty: matchedProperty.displayPricesTaxInclusive
			})
		}

		if (
			!_.isEmpty(matchedProperty) &&
			matchedProperty.displayPricesTimeline
		) {
			this.setState({
				displayedPriceFrequency: matchedProperty.displayPricesTimeline
			})
		}

		// Set initial active rateCode state
		const loyaltyAvailability = _.first(_.values(loyaltyRatesData))
		const loyaltyRoomTypes = _.get(loyaltyAvailability, 'roomTypes', null)
		const loyaltyRoomType = loyaltyRoomTypes && loyaltyRoomTypes.length ? loyaltyRoomTypes.find(roomType => roomType.roomTypeCode === cards.roomTypeCode) : []
		const loyaltyRoomRateCode = _.get(loyaltyRoomType, 'viewExtensions.roomRates[0].ratePlanCode', null)

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
			loyaltyRatesData &&
			loyaltyRoomRateCode
		) {
			this.setState({ currentRateCode: loyaltyRoomRateCode })
		} else if (urlData.ratePlanCode) {
			this.setState({ currentRateCode: queriedRate })
		} else if (payNowRate) {
			this.setState({ currentRateCode: payNowRate })
		} else if (payLaterRate) {
			this.setState({ currentRateCode: payLaterRate })
		} else if (payFeaturedRate) {
			if (
				cards &&
				cards.viewExtensions &&
				!_.isEmpty(cards.viewExtensions.roomRates)
			) {
				for (const roomRateKey in cards.viewExtensions.roomRates) {
					const currentRoomRate = cards.viewExtensions.roomRates[roomRateKey]

					if (
						currentRoomRate &&
						String(currentRoomRate.ratePlanCode)=== String(payFeaturedRate)
					) {
						this.setState({ currentRateCode: payFeaturedRate })
					}
				}
			}
		}
		// Check for up-sells and render modal up-sell button in place of select rate button
		if (
			cards &&
			cards.viewExtensions &&
			cards.viewExtensions.upSells &&
			!_.isEmpty(cards.viewExtensions.upSells)
		) {
			let availableUpSellRates = []

			for (const upSellKey in cards.viewExtensions.upSells) {
				const currentUpSell = cards.viewExtensions.upSells[upSellKey]

				if (
					availabilityData &&
					availabilityData[0] &&
					availabilityData[0][0] &&
					availabilityData[0][0].roomTypes
				) {
					const availableRoomData = availabilityData[0][0].roomTypes.find(function(room) {
						return String(room.roomTypeCode) === String(currentUpSell.roomTypeCode)
					})

					if (
						availableRoomData &&
						availableRoomData.viewExtensions &&
						availableRoomData.viewExtensions.roomRates
					) {
						for (const rateKey in availableRoomData.viewExtensions.roomRates) {
							if (availableRoomData.viewExtensions.roomRates[rateKey].ratePlanCode ===  currentUpSell.ratePlanCode){
								availableUpSellRates.push(currentUpSell)
							}
						}
					}
				}
			}

			this.setState({ currentUpSells: availableUpSellRates })
		}
	}

	componentWillUnmount() {
		document.body.classList.remove('multi-stage-open')
	}

	// Handle closing notification snackbar
	handleNotificationClose = ( event, reason ) => {
		if (reason === 'clickaway') {
			return
		}

		this.setState({ showNotification: false })
	}

	// Handle special packages accordion visibility state
	handleSpecialPackagesAccordion() {
		const { cards } = this.props
		const { specialPackagesExpanded, roomDetailsExpanded } = this.state

		if ( roomDetailsExpanded ) {
			this.setState({
				roomDetailsExpanded: !this.state.roomDetailsExpanded
			})
		}

		this.setState({
			specialPackagesExpanded: !specialPackagesExpanded
		})

		// Dispatch activeRoom GA events
		let roomSpecialRatesData = {
			roomType: cards.roomTypeCode,
			applicableOffers: cards.viewExtensions.specialPackageRates,
			expanded: !specialPackagesExpanded
		}

		triggerCustomGaEvent('analytics-roomSpecialRatesView', roomSpecialRatesData)
	}

	// Card gallery and lightbox
	renderFullScreenButton = (onClick, isFullScreen) => {
		const {
			configData,
			cards,
			roomGroup
		} = this.props

		const body = document.body
		const hotelLabels = configData.hotel.labels[0]

		if (isFullScreen) {
			body.classList.add('gallery-open')
		} else {
			body.classList.remove('gallery-open')
		}

		let buttonClassNames = 'bk-flow-room__card-media-full-screen btn btn-alt row center-xs middle-xs'

		if (yn(process.env.REACT_APP_COMPONENT_ROOM_IMAGE_FEATURE_TOGGLES)) {
			buttonClassNames = 'bk-flow-room__card-media-full-screen inc-media-toggles btn btn-alt row center-xs middle-xs'
		}

		return (
			<button
				id={ 'js-gallery-fullscreen__' + cards.roomTypeCode + '-' + roomGroup }
				className={buttonClassNames}
				onClick={ onClick }
				aria-label="Expand Gallery to Fullscreen"
			>
				{ process.env.REACT_APP_COMPONENT_ROOM_GALLERY_FULLSCREEN_BUTTON === 'close' && isFullScreen ?
					<i className="material-icons">close</i>
				:
					<Fragment>
						<img
							src={ isFullScreen ? zoomCloseIcon : zoomOpenIcon }
							alt="Room Gallery Zoom"
						/>
						<span className="u-mobile-hide-tablet-flex">
						{ hotelLabels.zoom ? hotelLabels.zoom : 'Zoom' }
						</span>
					</Fragment>
				}
			</button>
		)
	}

	handleFullScreen = (isFullScreen) => {
		const { cards } = this.props
		this.setState({ galleryFullScreen: isFullScreen })

		// Dispatch adaDescription GA events
		const roomGalleryFullScreenData = {
			roomType: cards.roomTypeCode,
			fullScreen: isFullScreen
		}

		triggerCustomGaEvent('analytics-roomGalleryFullScreen', roomGalleryFullScreenData)
	}

	handleImageClick = (event) => {
		const target = event.target

		if (target.classList.contains('fullscreen-modal')) {
			this.imageGallery.fullScreen()
		}
	}

	// Room description accordions
	handleToggleRoomDescription = () => {
		const { cards } = this.props
		this.setState({ roomDescriptionExpanded: !this.state.roomDescriptionExpanded })

		// Dispatch adaDescription GA events
		const roomDescriptionExpansionData = {
			roomType: cards.roomTypeCode,
			expanded: !this.state.roomDescriptionExpanded
		}

		triggerCustomGaEvent('analytics-roomDescriptionExpandView', roomDescriptionExpansionData)
	}

	// Room ada description accordions
	handleToggleAdaDescription = () => {
		const { cards } = this.props
		this.setState({ roomAdaDescriptionExpanded: !this.state.roomAdaDescriptionExpanded })

		// Dispatch adaDescription GA events
		const roomAdaDescriptionData = {
			roomType: cards.roomTypeCode,
			applicableOffers: cards.viewExtensions.adaDetails,
			expanded: !this.state.roomAdaDescriptionExpanded
		}

		triggerCustomGaEvent('analytics-roomAdaDescriptionView', roomAdaDescriptionData)
	}

	// Room rate stage for card type multi-stage
	handleToggleRoomRateStage = () => {
		const { cards } = this.props
		this.setState({roomRateStageExpanded: !this.state.roomRateStageExpanded})

		if (this.state.roomDetailsExpanded) {
			this.setState({
				roomDetailsExpanded: !this.state.roomDetailsExpanded
			})
		}

		// Dispatch adaDescription GA events
		const multiStageRateData = {
			roomType: cards.roomTypeCode,
			roomRates: cards.viewExtensions.roomRates,
			expanded: !this.state.roomRateStageExpanded
		}

		triggerCustomGaEvent('analytics-multiStageRatesView', multiStageRateData)
	}

	// Toggle up-sells modal if rates available
	handleToggleUpSells = (roomTypeCode, roomRateCode) => {
		this.setState({ upSellsExpanded: !this.state.upSellsExpanded })

		// Handle setting the currently selected room & rate for multi-stage card layout
		if (
			roomTypeCode &&
			roomRateCode
		) {
			this.setState({
				currentRoomType: roomTypeCode,
				currentRateCode: roomRateCode
			})
		}
	}

	handleToggleVirtualTour = () => {
		this.setState({
			virtualTourExpanded: !this.state.virtualTourExpanded
		})
	}

	renderCard = () => {
		const {
			activeCurrencyData,
			activeRoom,
			availabilityData,
			cards,
			configData,
			hotelDescriptiveInfoData,
			loyaltyRatesData,
			loyaltyRateLoading,
			multiRoomData,
			profileUser,
			roomGroup,
			roomKey,
			toggleActiveRoom,
			urlData,
		} = this.props

		const {
			roomRateStageExpanded,
			currentRateCode,
			currentRoomType,
			queriedRate,
			payNowRate,
			payLaterRate,
			currentUpSells
		} = this.state

		let activeHotelCode = null,
				activeHotelPhoneNumber = null,
				matchedProperty = null

		const totalRoomRates = cards.viewExtensions.roomRates.length

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			// Set phone # by config or synxis fallback
			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
			} else if (!_.isEmpty(availabilityData.hotelReservations) && availabilityData.hotelReservations[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber) {
				activeHotelPhoneNumber = availabilityData.hotelReservations[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
			} else if (!_.isEmpty(availabilityData.hotelResModifies) && availabilityData.hotelResModifies[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber) {
				activeHotelPhoneNumber = availabilityData.hotelResModifies[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
			}
		}

		// Check for activeRooms length
		const activeRoomsAmount = Object.keys(activeRoom).length,
					hotelLabels = configData.hotel.labels[0],
					totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

		// Init room offers rates data
		let availRatePlans = null,
				availRoomRates = null

		// set room offers rates data
		if (
			cards.viewExtensions &&
			cards.viewExtensions.roomRates
		) {
			availRoomRates = cards.viewExtensions.roomRates
		}

		if (
			availabilityData[roomGroup] &&
			availabilityData[roomGroup][0] &&
			availabilityData[roomGroup][0].ratePlans
		) {
			availRatePlans = availabilityData[roomGroup][0].ratePlans
		}

		// Initialize hotelDescriptiveInfo variables
		let unrefinedGuestRoom = null,
				unrefinedRoomDescription = null

		// Initialize and set hotelDescriptiveInfo data if matched
		if (
			yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
			hotelDescriptiveInfoData &&
			hotelDescriptiveInfoData.facilityInfo &&
			!_.isEmpty(hotelDescriptiveInfoData.facilityInfo.guestRooms)
		){
			unrefinedGuestRoom = hotelDescriptiveInfoData.facilityInfo.guestRooms.filter(function(room) {
				return room.Code === cards.roomTypeCode
			})

			if (
				unrefinedGuestRoom &&
				unrefinedGuestRoom[0] &&
				unrefinedGuestRoom[0].multimediaDescriptions &&
				unrefinedGuestRoom[0].multimediaDescriptions.textItems
			) {
				unrefinedRoomDescription = unrefinedGuestRoom[0].multimediaDescriptions.textItems.filter(function(description) {
					return description.title === 'Short Description'
				})
			}
		}

		// setting specialRates from synxis
		let specialPackageRates = null

		// setting specialRates from synxis
		if (
			cards.viewExtensions &&
			!_.isEmpty(cards.viewExtensions.specialPackageRates)
		) {
			specialPackageRates = cards.viewExtensions.specialPackageRates
		}

		// Init validation of special packages compared to roomRates
		let hasValidSpecialPackages = getValidSpecialPackages(specialPackageRates, availRatePlans, availRoomRates, cards.roomTypeCode),
				imageAssets = null

		// Setting gallery from synxis or fallback placeholder images
		if (
			yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
			!_.isEmpty(unrefinedGuestRoom) &&
			unrefinedGuestRoom[0] &&
			unrefinedGuestRoom[0].multimediaDescriptions &&
			unrefinedGuestRoom[0].multimediaDescriptions.imageItems
		) {

			// Use OtaHotelDescriptiveInfo data > availabilityData and Mediated assets
			const unrefinedImageData = unrefinedGuestRoom[0].multimediaDescriptions.imageItems

			imageAssets = []

			for (let imageKey in unrefinedImageData) {
				imageAssets.push(
					{
						original: unrefinedImageData[imageKey],
						originalAlt: 'Synxis OtaHotelDescriptiveInfo Image',
						originalTitle: 'Synxis OtaHotelDescriptiveInfo Image',
						description: 'Synxis OtaHotelDescriptiveInfo Image'
					}
				)
			}
		} else {
			// Use availabilityData and Mediated assets
			if (
				cards.viewExtensions &&
				cards.viewExtensions.roomTypeImages &&
				!_.isEmpty(cards.viewExtensions.roomTypeImages)
			) {
				imageAssets = cards.viewExtensions.roomTypeImages.map(imageEntry => (
					{
						caption: imageEntry.caption,
						description: imageEntry.description,
						original: imageEntry.path
					}
				))
			} else {
				imageAssets = [
					{
						original: placeholderImage,
						description: 'Brand placeholder image'
					}
				]
			}
		}

		const roomTypeRates = cards.viewExtensions.roomRates

		let roomTypeQueriedRatePlan = null
		let roomTypePayNowRatePlan = null
		let roomTypePayLaterRatePlan = null
		let roomTypePayPromoRates = []

		// Mapping queryStringRate rates
		const roomTypeQueriedRate = roomTypeRates.filter(function(prices){
			return prices.ratePlanCode === queriedRate
		})

		// Mapping payNow rates
		const roomTypePayNowRate = roomTypeRates.filter(function(prices){
			return prices['ratePlanCode'] === payNowRate
		})

		// Mapping payLater rates
		const roomTypePayLaterRate = roomTypeRates.filter(function(prices){
			return prices['ratePlanCode'] === payLaterRate
		})

		// find roomRates containing promo ratePlanId and construct array of all applicable room rate & rate plan data
		if (
			urlData &&
			urlData.promoCode
		) {
			for (const rateKey in roomTypeRates) {
				const promoRoomRateData = roomTypeRates[rateKey]

				if (
					promoRoomRateData &&
					promoRoomRateData.viewExtensions &&
					promoRoomRateData.viewExtensions.ratePlanId === urlData.promoCode
				) {
					const promoRatePlanData = availabilityData[0][0].ratePlans.filter(function (ratePlan) {
						return ratePlan.ratePlanCode === promoRoomRateData.ratePlanCode
					})

					// Construct array with feature roomRate and ratePlan data to render a button for each entry
					if (
						promoRoomRateData &&
						promoRatePlanData[0]
					) {
						roomTypePayPromoRates.push({
							roomRateData: promoRoomRateData,
							ratePlanData: promoRatePlanData[0]
						})
					}
				}
			}
		}

		// Init and set featured rate based on CMS viewExtensions
		let roomTypePayFeaturedRates = []

		if (
			cards.viewExtensions &&
			cards.viewExtensions.featuredRatePlans
		) {
			for (const rateKey in cards.viewExtensions.featuredRatePlans) {
				const featuredRoomRateData = roomTypeRates.filter(function(ratePlan){
					return ratePlan.ratePlanCode === String(cards.viewExtensions.featuredRatePlans[rateKey])
				})

				if (
					featuredRoomRateData &&
					featuredRoomRateData[0] &&
					featuredRoomRateData[0].ratePlanCode
				) {
					// Mapping payFeatured rate plan
					const featuredRatePlanData = availabilityData[0][0].ratePlans.filter(function (ratePlan) {
						return ratePlan.ratePlanCode === featuredRoomRateData[0].ratePlanCode
					})

					// Construct array with feature roomRate and ratePlan data to render a button for each entry
					if (
						featuredRatePlanData &&
						featuredRatePlanData[0]
					) {
						roomTypePayFeaturedRates.push({
							roomRateData: featuredRoomRateData[0],
							ratePlanData: featuredRatePlanData[0]
						})
					}
				}
			}
		}

		// Mapping queried rate plan
		if (
			roomTypeQueriedRate &&
			roomTypeQueriedRate[0]
		) {
			roomTypeQueriedRatePlan = availabilityData[0][0].ratePlans.filter(function (ratePlan) {
				return ratePlan.ratePlanCode === roomTypeQueriedRate[0].ratePlanCode
			})
		}

		// Mapping payNow rate plan
		if (
			roomTypePayNowRate &&
			roomTypePayNowRate[0] &&
			roomTypePayNowRate[0].ratePlanCode
		) {
			roomTypePayNowRatePlan = availabilityData[0][0].ratePlans.filter(function (ratePlan) {
				return ratePlan.ratePlanCode === roomTypePayNowRate[0].ratePlanCode
			})
		}

		// Mapping payLater rate plan
		if (
			roomTypePayLaterRate &&
			roomTypePayLaterRate[0] &&
			roomTypePayLaterRate[0].ratePlanCode
		) {
			roomTypePayLaterRatePlan = availabilityData[0][0].ratePlans.filter(function (ratePlan) {
				return ratePlan.ratePlanCode === roomTypePayLaterRate[0].ratePlanCode
			})
		}

		// Set card room rate state
		const setSelectedRoom = (activeRateId, roomTypeCode, ratePlanCode) => {
			this.setState({
				activeRateId: activeRateId,
				currentRoomType: roomTypeCode,
				currentRateCode: ratePlanCode,
				showNotification: true
			})

			let rateButtons = document.getElementsByClassName('bk-flow-room__price-col'),
					activeRateButton = document.getElementById(activeRateId)

			for (let i = 0; i < rateButtons.length; i++) {
				rateButtons[i].classList.remove('active-rate')
			}

			activeRateButton.classList.add('active-rate')
		}

		// Handle special packages accordion visibility state
		const handleRoomDetailsAccordion = () => {
			const { roomDetailsExpanded, specialPackagesExpanded, roomRateStageExpanded } = this.state

			if (specialPackagesExpanded) {
				this.setState({
					specialPackagesExpanded: !specialPackagesExpanded
				})
			}

			if (roomRateStageExpanded) {
				this.setState({
					roomRateStageExpanded: !roomRateStageExpanded
				})
			}

			this.setState({
				roomDetailsExpanded: !roomDetailsExpanded
			})

			// Dispatch activeRoom GA events
			let roomDetailsData = {
				roomType: cards.roomTypeCode,
				expanded: !roomDetailsExpanded
			}

			const { urlData } = this.props;
			const room = this.props.cards;

			const rates = room.viewExtensions.roomRates;
			let lowestPayNowRate = null;

			rates.reduce(function (res, obj) {
				if (obj.rates && _.get(obj.rates, '[0].total.amountAfterTax')) {
					lowestPayNowRate = obj.rates[0].total.amountAfterTax < res.rates[0].total.amountAfterTax ? obj : res
				}

				return lowestPayNowRate
			});

			const item = {
				item_name: room.roomDescription.name,
				item_id: room.roomTypeCode,
				price: lowestPayNowRate ? lowestPayNowRate.rates[0].total.amountBeforeTax : null,
				item_variant: lowestPayNowRate ? lowestPayNowRate.ratePlanCode : null,
				item_category: "Best Available Rate",
				quantity: '1',
				item_list_name: "Room",
			}

			triggerCustomGaEvent('verb_view_item', {
                arrival_date: urlData.startDate,
                departure_date: urlData.endDate,
                ecommerce: {
					items: [ item ]
				}
			})

			triggerCustomGaEvent('analytics-roomDetailView', roomDetailsData)
		}

		function renderRoomQuantityNotifications() {
			const notificationQuantityThreshold = Number(process.env.REACT_APP_COMPONENT_ROOM_QUANTITY_NOTIFICATION_THRESHOLD)
			let availableUnits = null

			for (let room in roomTypeRates) {
				if (
					roomTypeRates[room].roomTypeCode === cards.roomTypeCode &&
					currentRateCode === roomTypeRates[room].ratePlanCode
				) {
					availableUnits = _.get(roomTypeRates, '[room].numberOfUnits', null)
				}
			}

			if (
				availableUnits &&
				availableUnits > 0 &&
				availableUnits <= notificationQuantityThreshold
			) {
				return (
					<div className="bk-flow-room__card-media-notification">
						{ hotelLabels.only ? hotelLabels.only : 'Only' }&nbsp;
						{ availableUnits }&nbsp;
						{ hotelLabels.available ? hotelLabels.available : 'Available' }
					</div>
				)
			}
		}

		let loyaltyRateData = []

		const userLoyaltyTier = _.get(profileUser, 'loyaltyTier', null)
		const propertyLoyaltyTiers = _.get(hotelDescriptiveInfoData, 'viewExtensions.loyaltyTiers', [])
		const currentLoyaltyRates = propertyLoyaltyTiers.find(tier => {
			return tier.tier === userLoyaltyTier
		})
		const loyaltyRateCodes = _.get(currentLoyaltyRates, 'ratePlans', [])

		if (
			userLoyaltyTier &&
			!_.isEmpty(loyaltyRateCodes) &&
			!_.isEmpty(loyaltyRatesData)
		) {
			for (const loyaltyRateKey in loyaltyRateCodes) {
				const loyaltyRateCode = loyaltyRateCodes[loyaltyRateKey]
				const loyaltyAvailability = _.get(loyaltyRatesData, loyaltyRateCode, null)
				const loyaltyAvailabilityRatePlans = _.get(loyaltyAvailability, 'ratePlans', [])
				const loyaltyRoomTypes = _.get(loyaltyAvailability, 'roomTypes', [])
				const currentRoomType = loyaltyRoomTypes.find(roomType => roomType.roomTypeCode === cards.roomTypeCode)
				const currentRoomRate = _.get(currentRoomType, 'viewExtensions.roomRates[0]', null)
				const currentRatePlan = loyaltyAvailabilityRatePlans.find(ratePlan => ratePlan.ratePlanCode === loyaltyRateCode)

				if (
					!_.isEmpty(currentRoomRate) &&
					!_.isEmpty(currentRatePlan)
				) {
					loyaltyRateData.push(
						{
							roomRateData: currentRoomRate,
							ratePlanData: currentRatePlan
						}
					)
				}
			}
		}

		const renderCardLayout = () => {
			if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'multi-stage') {
				return (
					<Fragment>
						<BkFlowRoomCardMultiStage
							activeCurrencyData={activeCurrencyData}
							cards={cards}
							displayedPriceFrequency={this.state.displayedPriceFrequency}
							fullScreenEvent={this.handleFullScreen}
							gallery={imageAssets}
							hotelLabels={hotelLabels}
							hotelPhone={activeHotelPhoneNumber}
							imageClickEvent={this.handleImageClick}
							isFullScreen={this.state.galleryFullScreen}
							isTaxInclusiveProperty={this.state.isTaxInclusiveProperty}
							quantityNotifications={renderRoomQuantityNotifications()}
							renderFullScreenButton={this.renderFullScreenButton}
							roomDescriptionEvent={() => this.handleToggleRoomDescription()}
							roomDescriptionExpanded={this.state.roomDescriptionExpanded}
							roomGroup={roomGroup}
							roomRateStageEvent={this.handleToggleRoomRateStage}
							totalNights={totalNights}
							unrefinedGuestRoom={unrefinedGuestRoom}
							unrefinedRoomDescription={unrefinedRoomDescription}
							virtualTourEvent={() => this.handleToggleVirtualTour()}
						/>

						<BkFlowRoomCardRateStage
							activeCurrencyData={activeCurrencyData}
							activeRoomsAmount={activeRoomsAmount}
							adaDescriptionEvent={this.handleToggleAdaDescription}
							adaDescriptionExpanded={this.state.roomAdaDescriptionExpanded}
							cards={cards}
							currentRateCode={currentRateCode}
							currentUpSells={currentUpSells}
							gallery={imageAssets}
							hotelLabels={hotelLabels}
							isTaxInclusiveProperty={this.state.isTaxInclusiveProperty}
							multiRoomData={multiRoomData}
							payFeaturedRoomRates={!_.isEmpty(roomTypePayFeaturedRates) && roomTypePayFeaturedRates}
							payLaterRatePlan={roomTypePayLaterRatePlan && roomTypePayLaterRatePlan[0] && roomTypePayLaterRatePlan[0]}
							payLaterRoomRate={roomTypePayLaterRate && roomTypePayLaterRate[0] && roomTypePayLaterRate[0]}
							payNowRatePlan={roomTypePayNowRatePlan && roomTypePayNowRatePlan[0] && roomTypePayNowRatePlan[0]}
							payNowRoomRate={roomTypePayNowRate && roomTypePayNowRate[0] && roomTypePayNowRate[0]}
							payPromoRoomRates={!_.isEmpty(roomTypePayPromoRates) && roomTypePayPromoRates}
							queriedRatePlan={roomTypeQueriedRatePlan && roomTypeQueriedRatePlan[0] && roomTypeQueriedRatePlan[0]}
							queriedRoomRate={roomTypeQueriedRate && roomTypeQueriedRate[0] && roomTypeQueriedRate[0]}
							ratePlanData={availabilityData[0][0].ratePlans}
							roomGroup={roomGroup}
							roomRateStageEvent={this.handleToggleRoomRateStage}
							roomRateStageExpanded={roomRateStageExpanded}
							toggleActiveRoom={toggleActiveRoom}
							totalNights={totalNights}
							upSellsToggleEvent={(roomTypeCode, roomRateCode) => this.handleToggleUpSells(roomTypeCode, roomRateCode)}
							urlData={urlData}
						/>
					</Fragment>
				)
			} else if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'condensed') {
				return (
					<BkFlowRoomCardCondensed
						adaDescriptionEvent={this.handleToggleAdaDescription}
						adaDescriptionExpanded={this.state.roomAdaDescriptionExpanded}
						cards={cards}
						displayedPriceFrequency={this.state.displayedPriceFrequency}
						fullScreenEvent={this.handleFullScreen}
						gallery={imageAssets}
						hotelLabels={hotelLabels}
						imageClickEvent={this.handleImageClick}
						isFullScreen={this.state.galleryFullScreen}
						payPromoRoomRates={!_.isEmpty(roomTypePayPromoRates) && roomTypePayPromoRates}
						quantityNotifications={renderRoomQuantityNotifications()}
						queriedRatePlan={roomTypeQueriedRatePlan && roomTypeQueriedRatePlan[0] && roomTypeQueriedRatePlan[0]}
						queriedRoomRate={roomTypeQueriedRate && roomTypeQueriedRate[0] && roomTypeQueriedRate[0]}
						ratePlanData={availabilityData[0][0].ratePlans}
						renderFullScreenButton={this.renderFullScreenButton}
						roomDescriptionEvent={() => this.handleToggleRoomDescription()}
						roomDescriptionExpanded={this.state.roomDescriptionExpanded}
						roomDetailsAccordionEvent={handleRoomDetailsAccordion}
						roomDetailsAccordionExpanded={this.state.roomDetailsExpanded}
						roomGroup={roomGroup}
						totalNights={totalNights}
						totalRoomRates={totalRoomRates}
						unrefinedGuestRoom={unrefinedGuestRoom}
						unrefinedRoomDescription={unrefinedRoomDescription}
						toggleActiveRoom={toggleActiveRoom}
						urlData={urlData}
						virtualTourEvent={() => this.handleToggleVirtualTour()}
					/>
				)
			} else if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default-grid') {
				return (
					<BkFlowRoomCardDefaultGrid
						activeCurrencyData={activeCurrencyData}
						activeRoomsAmount={activeRoomsAmount}
						cards={cards}
						configData={configData}
						currentRateCode={currentRateCode}
						currentRoomType={currentRoomType}
						currentUpSells={currentUpSells}
						displayedPriceFrequency={this.state.displayedPriceFrequency}
						fullScreenEvent={this.handleFullScreen}
						gallery={imageAssets}
						hasValidSpecialPackages={hasValidSpecialPackages}
						hotelLabels={hotelLabels}
						imageClickEvent={this.handleImageClick}
						isFullScreen={this.state.galleryFullScreen}
						loyaltyRateData={loyaltyRateData}
						loyaltyRateLoading={loyaltyRateLoading}
						multiRoomData={multiRoomData}
						notificationCloseEvent={this.handleNotificationClose}
						payFeaturedRoomRates={!_.isEmpty(roomTypePayFeaturedRates) && roomTypePayFeaturedRates}
						payLaterRatePlan={roomTypePayLaterRatePlan && roomTypePayLaterRatePlan[0] && roomTypePayLaterRatePlan[0]}
						payLaterRoomRate={roomTypePayLaterRate && roomTypePayLaterRate[0] && roomTypePayLaterRate[0]}
						payNowRatePlan={roomTypePayNowRatePlan && roomTypePayNowRatePlan[0] && roomTypePayNowRatePlan[0]}
						payNowRoomRate={roomTypePayNowRate && roomTypePayNowRate[0] && roomTypePayNowRate[0]}
						payPromoRoomRates={!_.isEmpty(roomTypePayPromoRates) && roomTypePayPromoRates}
						quantityNotifications={renderRoomQuantityNotifications()}
						queriedRatePlan={roomTypeQueriedRatePlan && roomTypeQueriedRatePlan[0] && roomTypeQueriedRatePlan[0]}
						queriedRoomRate={roomTypeQueriedRate && roomTypeQueriedRate[0] && roomTypeQueriedRate[0]}
						renderFullScreenButton={this.renderFullScreenButton}
						roomDescriptionEvent={() => this.handleToggleRoomDescription()}
						roomDetailsAccordionExpanded={this.state.roomDetailsExpanded}
						roomDetailsAccordionEvent={handleRoomDetailsAccordion}
						roomGroup={roomGroup}
						setSelectedRoom={setSelectedRoom}
						showNotification={this.state.showNotification}
						specialPackagesAccordionEvent={this.handleSpecialPackagesAccordion}
						specialPackagesExpanded={this.state.specialPackagesExpanded}
						toggleActiveRoom={toggleActiveRoom}
						totalNights={totalNights}
						totalRoomRates={totalRoomRates}
						unrefinedGuestRoom={unrefinedGuestRoom}
						upSellsToggleEvent={() => this.handleToggleUpSells()}
						urlData={urlData}
						virtualTourEvent={() => this.handleToggleVirtualTour()}
					/>
				)
			} else {
				return (
					<BkFlowRoomCardDefault
						activeCurrencyData={activeCurrencyData}
						activeRoomsAmount={activeRoomsAmount}
						adaDescriptionEvent={this.handleToggleAdaDescription}
						adaDescriptionExpanded={this.state.roomAdaDescriptionExpanded}
						cards={cards}
						configData={configData}
						currentRateCode={currentRateCode}
						currentRoomType={currentRoomType}
						currentUpSells={currentUpSells}
						displayedPriceFrequency={this.state.displayedPriceFrequency}
						fullScreenEvent={this.handleFullScreen}
						gallery={imageAssets}
						hasValidSpecialPackages={hasValidSpecialPackages}
						hotelLabels={hotelLabels}
						imageClickEvent={this.handleImageClick}
						isTaxInclusiveProperty={this.state.isTaxInclusiveProperty}
						isFullScreen={this.state.galleryFullScreen}
						multiRoomData={multiRoomData}
						notificationCloseEvent={this.handleNotificationClose}
						payFeaturedRoomRates={!_.isEmpty(roomTypePayFeaturedRates) && roomTypePayFeaturedRates}
						payLaterRatePlan={roomTypePayLaterRatePlan && roomTypePayLaterRatePlan[0] && roomTypePayLaterRatePlan[0]}
						payLaterRoomRate={roomTypePayLaterRate && roomTypePayLaterRate[0] && roomTypePayLaterRate[0]}
						payNowRatePlan={roomTypePayNowRatePlan && roomTypePayNowRatePlan[0] && roomTypePayNowRatePlan[0]}
						payNowRoomRate={roomTypePayNowRate && roomTypePayNowRate[0] && roomTypePayNowRate[0]}
						payPromoRoomRates={!_.isEmpty(roomTypePayPromoRates) && roomTypePayPromoRates}
						quantityNotifications={renderRoomQuantityNotifications()}
						queriedRatePlan={roomTypeQueriedRatePlan && roomTypeQueriedRatePlan[0] && roomTypeQueriedRatePlan[0]}
						queriedRoomRate={roomTypeQueriedRate && roomTypeQueriedRate[0] && roomTypeQueriedRate[0]}
						renderFullScreenButton={this.renderFullScreenButton}
						roomDescriptionEvent={() => this.handleToggleRoomDescription()}
						roomDescriptionExpanded={this.state.roomDescriptionExpanded}
						roomDetailsAccordionEvent={handleRoomDetailsAccordion}
						roomDetailsAccordionExpanded={this.state.roomDetailsExpanded}
						roomGroup={roomGroup}
						roomKey={roomKey}
						roomRateStageExpanded={roomRateStageExpanded}
						roomRateStageEvent={this.handleToggleRoomRateStage}
						setSelectedRoom={setSelectedRoom}
						showNotification={this.state.showNotification}
						specialPackagesAccordionEvent={this.handleSpecialPackagesAccordion}
						specialPackagesExpanded={this.state.specialPackagesExpanded}
						toggleActiveRoom={toggleActiveRoom}
						totalNights={totalNights}
						totalRoomRates={totalRoomRates}
						unrefinedGuestRoom={unrefinedGuestRoom}
						unrefinedRoomDescription={unrefinedRoomDescription}
						upSellsToggleEvent={() => this.handleToggleUpSells()}
						urlData={urlData}
						virtualTourEvent={() => this.handleToggleVirtualTour()}
					/>
				)
			}
		}

		return renderCardLayout()
	}

	render() {
		const {
			activeCurrencyData,
			activeRoom,
			availabilityData,
			cards,
			configData,
			multiRoomData,
			roomGroup,
			roomKey,
			toggleActiveRoom,
			urlData,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		// Check for activeRooms length
		const activeRoomsAmount = Object.keys(activeRoom).length
		const featuredRatePlans = _.get(cards, 'viewExtensions.featuredRatePlans', [])

		// Init room offers rates data
		let availRatePlans = null,
				availRoomRates = null,
				totalNights = null,
				baseClassNames = 'bk-flow-room__card odd',
				roomVirtualTourSrc = null,
				roomFloorPlanSrc = null,
				roomMapUrlSrc = null

		if (Number(roomKey) % 2) {
			baseClassNames = 'bk-flow-room__card even'
		}

		if (
			urlData.startDate &&
			urlData.endDate
		) {
			totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')
		}

		// set room offers rates data
		if (
			cards.viewExtensions &&
			cards.viewExtensions.roomRates
		) {
			availRoomRates = cards.viewExtensions.roomRates
		}

		if (
			availabilityData[roomGroup] &&
			availabilityData[roomGroup][0] &&
			availabilityData[roomGroup][0].ratePlans
		) {
			availRatePlans = availabilityData[roomGroup][0].ratePlans
		}

		// setting specialRates from crs
		let specialPackageRates = null

		// setting specialRates from crs
		if (
			cards.viewExtensions &&
			!_.isEmpty(cards.viewExtensions.specialPackageRates)
		) {
			specialPackageRates = cards.viewExtensions.specialPackageRates
		}

		// Init validation of special packages compared to roomRates
		let hasValidSpecialPackages = getValidSpecialPackages(specialPackageRates, availRatePlans, availRoomRates, cards.roomTypeCode)

		if (
			cards &&
			cards.viewExtensions
		) {
			if (cards.viewExtensions.roomVirtualTourSrc) {
				roomVirtualTourSrc = cards.viewExtensions.roomVirtualTourSrc
			}

			if (cards.viewExtensions.mapLink) {
				roomMapUrlSrc = cards.viewExtensions.mapLink
			}

			if (
				cards.viewExtensions.roomFloorPlanSrc &&
				cards.viewExtensions.roomFloorPlanSrc.path
			) {
				roomFloorPlanSrc = cards.viewExtensions.roomFloorPlanSrc.path
			}
		}

		return (
			<div className={ this.state.roomDetailsExpanded || this.state.roomRateStageExpanded ?
				baseClassNames + ' active-card'
			:
				baseClassNames
			}>
				{ this.renderCard() }

				{ (
					process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default' ||
					process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default-grid'
				) &&
					yn(process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES) &&
					hasValidSpecialPackages && (
						<BkFlowRoomSpecialPackages
							roomTypeCode={get(cards, 'roomTypeCode')}
							specialPackagesExpanded={this.state.specialPackagesExpanded }
							roomGroup={ roomGroup }
							roomData={ cards }
							toggleActiveRoom={ toggleActiveRoom }
							toggleSpecialPackages={ this.handleSpecialPackagesAccordion }
						/>
					)
				}

				{
					process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT !== 'multi-stage' &&
					yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION) && (
						<BkFlowRoomDetails
							handleFullScreen={ this.handleFullScreen }
							roomDescriptionEvent={() => this.handleToggleRoomDescription()}
							roomDescriptionExpanded={this.state.roomDescriptionExpanded}
							roomData={ cards }
							roomDetailsExpanded={ this.state.roomDetailsExpanded }
							roomGroup={ roomGroup }
							roomFloorPlanSrc={roomFloorPlanSrc}
							roomMapUrlSrc={roomMapUrlSrc}
							virtualTourSrc={roomVirtualTourSrc}
							virtualTourEvent={() => this.handleToggleVirtualTour()}
						/>
					)
				}

				{process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default' &&
				 !yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING) &&
					process.env.REACT_APP_COMPONENT_ROOM_CARD_RATES_COMPONENT === 'drawer' ?
						<BkFlowRoomCardDynamicRatesDrawer
							activeCurrencyData={activeCurrencyData}
							cards={cards}
							currentRoomRate={ this.state.currentRateCode }
							currentUpSells={this.state.currentUpSells}
							featuredRatePlans={featuredRatePlans}
							hotelLabels={hotelLabels}
							ratePlanData={availabilityData[0][0].ratePlans}
							roomGroup={roomGroup}
							roomRateStageExpanded={this.state.roomRateStageExpanded}
							roomRateStageEvent={this.handleToggleRoomRateStage}
							toggleActiveRoom={toggleActiveRoom}
							totalNights={totalNights}
							upSellsToggleEvent={() => this.handleToggleUpSells()}
						/>
					: process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default' &&
						!yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING) ?
						<BkFlowRoomCardDynamicRatesAccordion
							activeCurrencyData={activeCurrencyData}
							cards={cards}
							currentRoomRate={ this.state.currentRateCode }
							currentUpSells={this.state.currentUpSells}
							isTaxInclusiveProperty={this.state.isTaxInclusiveProperty}
							ratePlanData={availabilityData[0][0].ratePlans}
							roomGroup={roomGroup}
							roomRateStageExpanded={this.state.roomRateStageExpanded}
							toggleActiveRoom={toggleActiveRoom}
							totalNights={totalNights}
							upSellsToggleEvent={() => this.handleToggleUpSells()}
						/>
					:
						null
				}

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING) &&
					process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'default' &&
					yn(process.env.REACT_APP_COMPONENT_ROOM_MOBILE_SELECT_BUTTON) && (
						<div className="bk-flow-room__mobile-select-button">
							<BkFlowRoomCardDefaultSelectButton
								currentRoomType={this.state.currentRoomType}
								currentRateCode={this.state.currentRateCode}
								currentUpSells={this.state.currentUpSells}
								toggleActiveRoom={toggleActiveRoom}
								upSellsToggleEvent={() => this.handleToggleUpSells()}
								roomGroup={roomGroup}
							/>
						</div>
					)
				}

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING) &&
					yn(process.env.REACT_APP_COMPONENT_ROOM_MOBILE_SKIP_ROOM_STEP_BUTTON) &&
					multiRoomData.isMultiRoom &&
					activeRoomsAmount === multiRoomData.multiRoomTotal && (
						<BkFlowRoomCardSkipStepButton customClass="mobile" />
					)
				}

				{
					this.state.currentRoomType &&
					this.state.currentRateCode &&
					!_.isEmpty(this.state.currentUpSells) &&
					this.state.upSellsExpanded &&
						<BkFlowRoomCardUpSells
							currentRoomData={ cards }
							currentRoomRate={ this.state.currentRateCode }
							currentRoomType={ this.state.currentRoomType }
							currentUpSells={this.state.currentUpSells}
							roomGroup={roomGroup}
							toggleActiveRoom={ toggleActiveRoom }
							toggledState={this.state.upSellsExpanded}
							toggleEvent={() => this.handleToggleUpSells()}
							totalNights={ totalNights }
						/>
				}

				{ roomVirtualTourSrc &&
					<BkFlowRoomCardVirtualTour
						hotelLabels={hotelLabels}
						virtualTourSrc={roomVirtualTourSrc}
						virtualTourExpanded={this.state.virtualTourExpanded}
						virtualTourEvent={() => this.handleToggleVirtualTour()}
					/>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
		multiRoomData: state.multiRoomData,
		hotelDescriptiveInfoData: state.hotelDescriptiveInfo.hotelInfo,
		availabilityData: state.availabilityData.availability,
		enhancementData: state.enhancementData,
		activeStep: state.activeStepData.activeStep,
		activePromo: state.activePromoData.activePromo,
		activeRoom: state.activeRoomData,
		activeCurrencyData: state.activeCurrencyData,
		loyaltyRatesData: state.loyaltyRatesData.availability,
		loyaltyRateLoading: state.loyaltyRatesData.loading,
		profileUser: state.profileUserData.user,
		roomRateDetailsData: state.roomRateDetailsData
	}
}

const mapDispatchToProps = (dispatch) => ({
	toggleActiveRoom(
		availabilityData,
		roomTypeVal,
		ratePlanVal,
		roomGroup,
		activeStep,
		multiRoomData,
		configData,
		urlData,
		enhancementData,
		roomRateDetailsData,
		activeLoyaltyAvailability
	) {
		let activeRoomData = [],
				activeGroup = {}

		let toggledRoomType = availabilityData[roomGroup][0].roomTypes.filter(function(room){
			return room.roomTypeCode === roomTypeVal
		})

		// Filter ratePlans for activeRate value
		let toggledRoomRatePlan = availabilityData[roomGroup][0].ratePlans.filter(function(ratePlans) {
			return ratePlans.ratePlanCode === ratePlanVal
		})

		// Filter loyalty store rates for active rate data
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
			!_.isEmpty(activeLoyaltyAvailability)
		) {
			toggledRoomType = activeLoyaltyAvailability.roomTypes.filter(function(room){
				return room.roomTypeCode === roomTypeVal
			})

			toggledRoomRatePlan = activeLoyaltyAvailability.ratePlans.filter(function(ratePlans) {
				return ratePlans.ratePlanCode === ratePlanVal
			})
		}

		const toggledRoomRate = toggledRoomType[0].viewExtensions.roomRates.filter(function(roomRates){
			return roomRates.roomTypeCode === roomTypeVal && roomRates.ratePlanCode === ratePlanVal
		})

		// Combine selected roomType and ratePlan into activeRoomData
		activeRoomData.push(toggledRoomType, toggledRoomRate, toggledRoomRatePlan)

		activeGroup[roomGroup] = activeRoomData

		// Snap to top of form
		window.scrollTo(0,0)

		// Handle step actions for multi-room V. single room
		function handleStepActions() {
			// currentMultiStep increment = 0 multiRoomTotal increment = 1
			if (multiRoomData.isMultiRoom && multiRoomData.currentMultiRoomStep === multiRoomData.multiRoomTotal - 1) {
				return dispatch(setActiveStep(activeStep + 1))
			} else if (multiRoomData.isMultiRoom) {

				// Handle fetch next room avail
				if (_.isEmpty(availabilityData[roomGroup + 1])) {
					dispatch(fetchAvailabilityData(roomGroup + 1))
				}
				return dispatch(manageMultiRoom(multiRoomData.isMultiRoom, multiRoomData.multiRoomTotal, multiRoomData.currentMultiRoomStep + 1))
			} else {
				return dispatch(setActiveStep(activeStep + 1))
			}
		}

		// Retrieve enhancements by selected roomType for reservationServicesComponent flow
		function handlePreResEnhancements() {
			if (
				yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
				!enhancementData.enhancements[roomTypeVal + '-' + ratePlanVal] + '-' + roomGroup
			) {
				dispatch(fetchEnhancementsData(urlData, roomTypeVal, ratePlanVal, roomGroup))
			}
		}

		// Dispatch activeRoom GA event
		triggerCustomGaEvent('analytics-toggleActiveRoom', activeGroup)

		// Fetch additional rate details not included in avail-rooms as needed VIA env config
		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_FETCH_RATE_DETAILS)) {
			let fetchRateDetails = true

			if (
				roomRateDetailsData &&
				roomRateDetailsData.roomRateDetails &&
				roomRateDetailsData.roomRateDetails[roomTypeVal + '-' + ratePlanVal + '-' + roomGroup]
			) {
				fetchRateDetails = false
			}

			if (
				roomTypeVal &&
				ratePlanVal &&
				fetchRateDetails
			) {
				dispatch(fetchRoomRateDetails(roomGroup, roomTypeVal, ratePlanVal))
			}
		}


		// Dispatch activeRoom & update step to payment
		return (
			dispatch(setActiveRoom(activeGroup)),
			handlePreResEnhancements(),
			handleStepActions()
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomCard)


// WEBPACK FOOTER //
// ./src/components/room/BkFlowRoomCard.js